class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Header menus open on hover instead of requiring a click. Bound on the
    // <details> element itself (not the <header-menu> wrapper) so the hover
    // hit area matches whatever Dawn's header CSS already positions/sizes
    // for the dropdown. Native click/keyboard toggling (via <summary>'s
    // built-in behavior, inherited from DetailsDisclosure) still works
    // unchanged alongside this — touch devices never fire mouseenter, so
    // they naturally keep the tap-to-toggle behavior.
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseTimeout);

    // Only one menu open at a time, so a fast pointer sweep across the top-
    // level items doesn't leave two dropdown panels visible at once while
    // the previous one's close delay (below) is still pending.
    const inlineMenu = this.closest('.header__inline-menu');
    if (inlineMenu) {
      inlineMenu.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    }

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    // A short delay absorbs the pointer briefly leaving the <details>
    // element's hit area while moving from the summary down into the
    // dropdown panel below it, instead of the menu flickering closed.
    this.hoverCloseTimeout = setTimeout(() => this.close(), 150);
  }

  disconnectedCallback() {
    clearTimeout(this.hoverCloseTimeout);
  }
}

customElements.define('header-menu', HeaderMenu);
